// extracted by css-extract-rspack-plugin
export default {"root":"FilterPill-module__root___UZYdN","icon":"FilterPill-module__icon___NmvuX"};